const BUILD_ID = '5.2.3'
export { BUILD_ID }
